// extracted by mini-css-extract-plugin
module.exports = {"container":"buttons-image-size_container__22ynd","active":"buttons-image-size_active__1K_kk"};